// extracted by mini-css-extract-plugin
export default {"CreateFormNew":"CreateFormNew_CreateFormNew__aGEXm"};